import countries from '../assets/constants/shopify/countries.json'
import { representativeFor } from './storefrontLocales'

import type { ContentLocale } from './constants'

// Ranked by 90-day product page views. Colombia and Latvia are excluded as bot traffic.
const HREFLANG_COUNTRIES = [
  'FR', 'DE', 'NL', 'SG', 'ES', 'IE', 'BE', 'IT', 'SE', 'GR',
  'DK', 'AT', 'NO', 'FI', 'PL', 'PT', 'AE', 'JP', 'CZ', 'HK',
  'IN', 'ZA', 'HU', 'MX', 'TR',
]

export type HreflangClaim = { country: string; localeCode: string }

// The target is derived, not listed, so a claim cannot contradict the canonical.
export function hreflangClaims(locales?: ContentLocale[]): HreflangClaim[] {
  return HREFLANG_COUNTRIES.reduce<HreflangClaim[]>((claims, country) => {
    const currency = countries.find((entry) => entry.isoCode === country)?.currency?.isoCode

    if (currency) claims.push({ country, localeCode: representativeFor(currency, locales) })

    return claims
  }, [])
}
